module.exports = __webpack_public_path__ + "media/images/main-bg2-5084615ab50212b98703f00066009243.png";